import axios from "../axios";

const api = {
  createSupplierDecarbonizationPlanQuestionnaire({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan`, data, headers)
      .then(({ data }) => data);
  },

  updateSupplierDecarbonizationPlanQuestionnaire({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan/${id}`, data, headers)
      .then(({ data }) => data);
  },

  attachDecarbonizationPlanDocumentation({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan/decarbonization-plan-documentation`,
      data, headers)
      .then(({ data }) => data);
  },

  attachLatestSustainabilityReport({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan/latest-sustainability-report`,
      data, headers)
      .then(({ data }) => data);
  },

  attachDeforestationPlanDocumentation({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan/deforestation-plan-documentation`,
      data, headers)
      .then(({ data }) => data);
  },

  getDecarbAttachment({ questionnaireId, attachmentId }, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan/attachment/${attachmentId}`,
      config)
      .then(({ data, headers }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ?? "Attachment";
        link.href = url;
        link.setAttribute("download", defaultFileName);
        document.body.appendChild(link);
        link.click();
        return true;
      });
  },

  deleteDecarbAttachment({ questionnaireId, attachmentId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/supplier-questionnaires/${questionnaireId}/decarbonization-plan/attachment/${attachmentId}`,
      headers).then(({ data, status }) => {return {...data, status: status}});
  }
};

export default api;